import Dropdown from './components/dropdown.vue';

export default [
  Dropdown,
];



// WEBPACK FOOTER //
// ./src/js/components.js